import type { HttpErrorResponse } from '@angular/common/http';

/**
 * Check if reCAPTCHA v2 is required based on the error response
 * @param response - The HTTP error response or error object
 * @returns true if reCAPTCHA v2 should be used, false otherwise
 */
export function shouldUseRecaptchaV2(
	response: HttpErrorResponse | { error?: { errors?: { status: number }[] } },
): boolean {
	if (response?.error?.errors?.[0]?.status === 403) {
		return true;
	}

	return false;
}
